import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchReconCompanyList } from '../actions/reconciliationTypes'

const useFetchingManagedReconCompanies = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchReconCompanyList())
  }, [dispatch])
}

export default useFetchingManagedReconCompanies
